import React from 'react';

const Card = ({ children, className = '', hover = false, ...props }) => {
  const baseClasses = 'bg-white rounded-md shadow-soft overflow-hidden';
  const hoverClasses = hover ? 'hover:shadow-soft-lg transition-smooth cursor-pointer' : '';

  return (
    <div className={`${baseClasses} ${hoverClasses} ${className}`} {...props}>
      {children}
    </div>
  );
};

export default Card;
